import {Splide} from "@splidejs/splide";
import { SetBackgroundColorAfterBefore } from "../splideExtensions/setBackgroundColorAfterBefore";

const googleReviewSlider = {
    init() {
        if (document.getElementById('google-review-slider')) {
            const arrowPath = 'M26.0298 19.4703C26.3204 19.7609 26.3204 20.239 26.0298 20.5297L17.0298 29.5297C16.7392 29.8203 16.261 29.8203 15.9704 29.5297C15.6798 29.239 15.6798 28.7609 15.9704 28.4703L24.4407 20L15.9704 11.5297C15.6798 11.239 15.6798 10.7609 15.9704 10.4703C16.261 10.1797 16.7392 10.1797 17.0298 10.4703L26.0298 19.4703Z';

            var slider = new Splide( '#google-review-slider', {
                type: 'loop',
                padding: '10%',
                pagination: true,
                perPage: 6,
                arrows : true,
                arrowPath: arrowPath,
                autoplay: false,
                gap: '1rem',
                drag: false,
                destroy: true,
                breakpoints: {
                    1279: {
                        perPage: 5,
                        destroy: true,
                    },
                    1024: {
                        perPage: 5,
                        start: 0,
                        destroy: true,
                    },
                    767: {
                        drag: 'free',
                        perPage: 2,
                        start: 1,
                        focus: "center",
                        destroy: false,
                    },
                }
            });
            slider.mount({ SetBackgroundColorAfterBefore });
        }
    },
};
export { googleReviewSlider as default };
